<template>
    <div class="info">

        <div class="info_list">
            <div class="info_title">
                <div>报考信息</div>
            </div>

                <div class="van-cell van-cell--large van-field">
                    <div class="van-cell__title van-field__label">
                        <span>报考科目</span>
                    </div>
                    <div class="van-cell__value van-field__value">
                        <div class="van-field__body">
                            {{skuinfo.title}}
                        </div>
                    </div>
                </div>
            <div class="van-cell van-cell--large van-field">
                <div class="van-cell__title van-field__label">
                    <span>报考证书</span>
                </div>
                <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                        {{skuinfo.name}}
                    </div>
                </div>
            </div>
            <div class="van-cell van-cell--large van-field">
                <div class="van-cell__title van-field__label">
                    <span>教  学  点</span>
                </div>
                <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                        {{item.venue}}
                    </div>
                </div>
            </div>
            <div class="van-cell van-cell--large van-field">
                <div class="van-cell__title van-field__label">
                    <span>报考费用</span>
                </div>
                <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                        {{skuinfo.price}}
                    </div>
                </div>
            </div>
        </div>
        <div class="info_list">
            <div class="info_title">
                <div>填写基本信息</div>
            </div>


            <van-cell-group>

              <div class="van-cell van-cell--large van-field" v-if="btnstate == 0">
                <div class="van-cell__title van-field__label">
                  <span>身份证照片</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body"   style="justify-content: space-between;">
                    <van-image v-if="form.idcard_img"  width=".5rem" height=".5rem" :src="form.idcard_img" @click="viewPic(form.idcard_img)"/>
                  </div>
                </div>
              </div>

                <van-field v-model="form.realname" label="姓名" size="large" readonly placeholder="请输入用户名" :rules="[{ required: true, message: '请填写用户名' }]"/>

                <div class="van-cell van-cell--large van-field">
                    <div class="van-cell__title van-field__label">
                        <span>性别</span>
                    </div>
                    <div class="van-cell__value van-field__value">
                        <div class="van-field__body">
                            <van-radio-group v-model="form.gender" direction="horizontal" disabled>
                                <van-radio :name="1">男</van-radio>
                                <van-radio :name="2">女</van-radio>
                            </van-radio-group>
                        </div>
                    </div>
                </div>

                <div class="van-cell van-cell--large van-field">
                    <div class="van-cell__title van-field__label">
                        <span>蓝底照片</span>
                    </div>
                    <div class="van-cell__value van-field__value">
                        <div class="van-field__body"   style="justify-content: space-between;">
                            <van-image v-if="form.cert_img"  width=".5rem" height=".5rem" :src="form.cert_img" @click="viewPic(form.cert_img)"/>
                        </div>
                    </div>
                </div>

              <div class="van-cell van-cell--large van-field" v-if="typeof form.cert_img2 !='undefined' && form.cert_img2">
                <div class="van-cell__title van-field__label">
                  <span>救生员证书</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body"   style="justify-content: space-between;">
                    <van-image v-if="form.cert_img2"  width=".5rem" height=".5rem" :src="form.cert_img2" @click="viewPic(form.cert_img2)"/>
                  </div>
                </div>
              </div>

              <div class="van-cell van-cell--large van-field" v-if="typeof form.cert_img3 !='undefined' && form.cert_img3">
                <div class="van-cell__title van-field__label">
                  <span>资格证书</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body"   style="justify-content: space-between;">
                    <van-image v-if="form.cert_img3"  width=".5rem" height=".5rem" :src="form.cert_img2" @click="viewPic(form.cert_img3)"/>
                  </div>
                </div>
              </div>


                <van-field v-model="form.birthday"  readonly size="large" center readonly label="出生年月" placeholder="请选择出生年月" ></van-field>
                <van-field v-model="form.idcard" label="身份证号" size="large" placeholder="请输入身份证号" readonly/>
                <!-- <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="form.political"
                        label="政治面貌"
                        placeholder="点击选择政治面貌"
                        disabled
                /> -->

                <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="form.edu"
                        label="最高学历"
                        placeholder="点击选择最高学历"
                        disabled
                />


                <van-field v-model="form.address" label="详细地址" size="large" placeholder="请输入详细地址"  readonly :rules="[{ required: true, message: '请填写详细地址' }]"/>
                <!--          <van-field v-model="form.mobile" label="联系电话" size="large" placeholder="请输入联系电话" :rules="[{ required: true, message: '请填写联系电话' }]"/>-->

                <!--<van-field v-model="address" label="详细地址" size="large" placeholder="请输入详细地址" />-->
                <van-field v-model="form.mobile" size="large" center clearable readonly label="联系电话" placeholder="请输入联系电话" >
                </van-field>

            </van-cell-group>

        </div>
        <div class="info_list">
            <div class="info_title">
                <div>教育经历</div>
            </div>


            <div class="hos" v-for="(item,index) in edus" :key="index" v-if="edus.length>0">
                <div class="hos-t">
                    <div>学历{{index+1}}</div>
                </div>
                <div class="hotlist">
                    <div>
                        <div>毕业时间：</div>
                        <div>{{item.date}}</div>
                    </div>
                    <div>
                        <div>毕业学校：</div>
                        <div>{{item.school}}</div>
                    </div>
                    <div>
                        <div>专业：</div>
                        <div>{{item.profession}}</div>
                    </div>
                    <div>
                        <div>学制：</div>
                        <div>{{item.year}}</div>
                    </div>
                    <div>
                        <div>学位：</div>
                        <div>{{item.degree}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="info_other">
            <div class="con">
                <div class="con-t">工作简历</div>
                <van-field
                        class="textarea"
                        v-model="resume"
                        rows="5"
                        type="textarea"
                        placeholder="写点什么吧，让你的简历更漂亮 "
                        readonly
                />
            </div>
            <div class="con two">
                <div class="con-t">运动成就</div>
                <van-field
                        class="textarea"
                        v-model="achievement"
                        rows="5"
                        type="textarea"
                        placeholder="生命在于运动，运动成就不一样的美。请记录您的运动成就 ... "
                        readonly
                />
            </div>

          <div class="invoice_list" v-if="other">
            <div class="info_title">
              <div>其他信息</div>
            </div>
            <div class="van-cell van-cell--large van-field">
              <van-checkbox v-model="other.issh" shape="square"  disabled >是否持上海市游泳救生协会颁发的救生员证</van-checkbox>
            </div>
            <div class="van-cell van-cell--large van-field">
              <van-checkbox v-model="other.isyear3" shape="square" disabled>是否期满三年</van-checkbox>
            </div>

            <div class="van-cell van-cell--large van-field">
              <van-checkbox v-model="other.istuoshen" shape="square" disabled>是否有脱审</van-checkbox>
            </div>

            <div class="van-cell van-cell--large van-field">
              <van-checkbox v-model="other.isshigu" shape="square" disabled>是否有重大责任事故</van-checkbox>
            </div>

          </div>

            <div class="con two" v-if="reback">
                <div class="con-t">拒绝理由</div>
                <van-field
                        class="textarea"
                        v-model="reback"
                        rows="5"
                        type="textarea"
                        placeholder="写点什么吧，让你的简历更漂亮 "
                        readonly
                />
            </div>






          <div class="invoice_list" v-if="invoice">
            <div class="info_title">
              <div>发票信息</div>
            </div>
            <van-cell-group >

              <div v-if="invoice.type == '1'">
                <div class="van-cell van-cell--large van-field">
                  <div class="van-cell__title van-field__label">
                    <span>个人名称</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      {{invoice.name}}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="van-cell van-cell--large van-field">
                  <div class="van-cell__title van-field__label">
                    <span>单位名称</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      {{invoice.company}}
                    </div>
                  </div>
                </div>

                <div class="van-cell van-cell--large van-field">
                  <div class="van-cell__title van-field__label">
                    <span>纳税人识别码</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      {{invoice.code}}
                    </div>
                  </div>
                </div>

              </div>

              <div class="van-cell van-cell--large van-field">
                <div class="van-cell__title van-field__label">
                  <span>收票人手机</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    {{invoice.mobile}}
                  </div>
                </div>
              </div>

              <div class="van-cell van-cell--large van-field">
                <div class="van-cell__title van-field__label">
                  <span>收票人邮箱</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    {{invoice.email}}
                  </div>
                </div>
              </div>
            </van-cell-group>
          </div>








        </div>





        <div class="footer" v-if="btnstate == 0">
            <van-button type="warning" @click="show=true" plain hairline round class="btn1">审核不通过</van-button>
            <van-button type="primary" @click="regCheck(1)"  hairline round class="btn1">审核通过</van-button>
        </div>

        <div class="footer" v-else-if="btnstate == 1">
            <div class="mvbutton" @click="goPay">去支付</div>
        </div>

        <div class="footer" v-else-if="btnstate == 2">
            <div class="mvbutton" @click="gonext">返回</div>
        </div>
        <div class="footer" v-else-if="btnstate == 3">
            <!-- <div class="mvbutton" @click="gonext">已支付</div> -->
            <van-button type="warning" @click="goRefund(btnCancal.state)"  hairline round class="btn1" v-if="btnCancal">{{btnCancal.label}}</van-button>
            <van-button type="primary" @click="gonext"  hairline round class="btn1">已支付</van-button>
        </div>
      <div class="footer" v-else-if="btnstate == 9">
        <div class="mvbutton" @click="gonext">支付超时</div>
      </div>
      <div class="footer" v-else-if="btnstate == 99">
            <div class="mvbutton" @click="gonext">已退款</div>
        </div>
        <van-dialog v-model="show" title="拒绝理由" show-cancel-button @confirm="confirm" @cancel="show=false">
          <van-field v-model="reback" rows="3" autosize type="textarea" placeholder="请输入理由"  class="ctextarea"/>
        </van-dialog>
    </div>

</template>
<script>
    import utils from '../../../libs/utils'
    import wechat from '../../../libs/wechat'
   import {Cell, CellGroup,Field,RadioGroup, Radio,Button,Calendar,Uploader,Toast,Picker,Popup,Dialog,Image,ImagePreview,CheckboxGroup,Checkbox} from 'vant'
    import axios from 'axios'
    export default {
        name: "coinRecord",
        components: {
            vanCell:Cell,
            vanCellGroup:CellGroup,
            vanField:Field,
            vanRadioGroup:RadioGroup,
            vanRadio:Radio,
            vanButton:Button,
            vanCalendar:Calendar,
            vanUploader:Uploader,
            vanPicker:Picker,
            vanPopup:Popup,Dialog,
            vanImage:Image,
            ImagePreview,
            vanCheckboxGroup:CheckboxGroup,
            vanCheckbox:Checkbox
        },
        data() {
            return {
                page:1,
                form:{"realname":"","address":"","gender":1,"idcard":"","mobile":"","birthday":"","idcard_img":"","cert_img":""},
                resume:'',
                edus:[],
                forms:{},

                type:1,//1新增，2修改
                id:'',
                achievement:'',
                btnstate:'',
                item:'',
                skuinfo:{},
                show: false,
                reback: '',
                invoice:{},
                other:{},
                btnCancal:{}
            }
        },
        methods: {
            gonext(){
                // let
                this.$router.back(-1)
            },
            viewPic(picurl)
            {
                ImagePreview([picurl]);
            },
            getDetail(){
                let that = this;
                this.$api.user.myApplydetail({id:this.id}).then((res)=>{
                    if(res.code==200){
                        that.form = res.data.forms
                        that.edus = res.data.edus
                        that.resume = res.data.resume?res.data.resume:"无"
                        that.achievement = res.data.achievement?res.data.achievement:"无"
                        that.btnstate = res.data.btnstate
                        that.item = res.data
                        that.skuinfo = res.data.skuinfo
                        that.reback = res.data.reback
                        that.invoice = res.data.invoice?JSON.parse(res.data.invoice):null
                        that.other = res.data.other?res.data.other:null
                        that.btnCancal = res.data.btnCancal
                        console.log(that.invoice,'that.invoice')
                    }
                })
            },
            confirm() {
                if(!this.reback)
                {
                    Dialog.alert({
                        title: '提示',
                        message: '请输入拒绝理由',
                    })
                    return;
                }
                this.$api.order.regCheck({id:this.id,op:2,reback:this.reback}).then((res)=>{
                    if(res.code==200)
                    {
                        this.getDetail()
                    }
                })
            },
            regCheck(op)
            {
                let that = this;
                Dialog.confirm({
                    title: '提示',
                    message: '您确定要这么操作吗？',
                }).then(() => {
                    that.$api.order.regCheck({id:this.id,op:op}).then((res)=>{
                        if(res.code==200)
                        {
                            that.getDetail()
                        }
                    })
                })
            },
            goRefund(state)
            {
                if(state == 1)
                {
                  this.$router.push({name:'refundorder',params:{'orderid':this.id}})
                }else{
                  return false;
                }
            },
            goPay()
            {
                let that = this;
                this.$api.order.applyPay({orid:that.item.id,order_sn:that.item.order_sn}).then((res)=>{
                    if(res.code==200){
                        if(res.data.shipment)
                            wechat.jsPayLocal(res.data.shipment)
                        else{
                            Dialog.confirm({
                                title: '提示',
                                message: '订单支付异常，请联系管理员',
                            });
                        }
                        console.log(res.data.shipment,'form')
                    }
                })
            }


        },
        mounted() {
            this.$nextTick(() => {
                this.id = this.$route.params.id
                this.getDetail()
            })
        }
    }
</script>

<style lang="less" src="./applydetail.less"></style>
